import gql from 'graphql-tag';

export default gql`
query listFA_InvoiceOrders($args: FA_InvoiceOrdersInputs!){
    fakturaAssist{
    	listFA_InvoiceOrders(args: $args){
    		id
			date
			customerId
			customerNr
			name
			orderId
			total
			orderType
			pdfLink
 		}
 	}
}`;
